import { render, staticRenderFns } from "./integral-records.vue?vue&type=template&id=b858aa6a&scoped=true"
import script from "./integral-records.vue?vue&type=script&lang=js"
export * from "./integral-records.vue?vue&type=script&lang=js"
import style0 from "./integral-records.vue?vue&type=style&index=0&id=b858aa6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b858aa6a",
  null
  
)

export default component.exports